import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=fabd3d94&scoped=true"
import script from "./UserRating.vue?vue&type=script&lang=ts"
export * from "./UserRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd3d94",
  null
  
)

export default component.exports